import "./customDatePicker.scss";
import "react-multi-date-picker/styles/colors/teal.css";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { todayDate } from "../../utils/todayDate";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
export default function CustomDatePicker({type = "input", date, setDate, minDate = null, maxDate = null, inputWidth}) {
  const textFormat = "dddd YYYY/MM/DD";
  const inputFormat = "YYYY/MM/DD";
  function GregorianHeader({ state }) {
  const baseDate = state?.date || new DateObject({ calendar: persian });

  const startOfPersianMonth = new DateObject(baseDate).toFirstOfMonth();
  const endOfPersianMonth = new DateObject(baseDate).toLastOfMonth();

  const gStart = new DateObject(startOfPersianMonth).convert(
    gregorian,
    gregorian_en
  );

  const gEnd = new DateObject(endOfPersianMonth).convert(
    gregorian,
    gregorian_en
  );

  const text =
    gStart.month.name === gEnd.month.name && gStart.year === gEnd.year
      ? gStart.format("MM MMMM YYYY")
      : `${gStart.format("MM MMMM YYYY")} / ${gEnd.format("MM MMMM YYYY")}`;

  return (
    <div className="gregorian-header">
      {text}
    </div>
  );
}
  GregorianHeader.defaultProps = {
    position: "top",
  };
  
  return (
    <div className="customDatePicker">
      <DatePicker
        className="teal"
        inputClass={type}
        plugins={[
          weekends(),
          <GregorianHeader />
        ]}
        // plugins={[weekends()]}
        calendar={persian}
        locale={persian_fa}
        calendarPosition="bottom-center"
        value={date}
        format={type === "text" ? textFormat : inputFormat}
        onChange={setDate}
        minDate={minDate != null && new DateObject({ calendar: persian }).subtract(minDate, "days")}
        maxDate={maxDate != null && maxDate}
        style={{width:inputWidth}}
        mapDays={({ date }) => {
          const gDate = new DateObject(date).convert(
            gregorian,
            gregorian_en
          );

          return {
            children: (
              <div className="day-container">
                <span className="jalali-day">
                  {date.format("D")}
                </span>

                <span className="gregorian-day">
                  {gDate.format("M")}/
                  {gDate.format("D")}
                </span>
              </div>
            ),
          };
        }}
      >
        <button
          className="todayButton"
          onClick={() => setDate(todayDate())}
        >
          امروز 
        </button>
      </DatePicker>
    </div>
  );
}
